function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 28,
  r: 28,
  fill: "#00C184"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m16.8 40.32 1.653-6.04a11.63 11.63 0 0 1-1.556-5.828C16.9 22.027 22.13 16.8 28.552 16.8a11.58 11.58 0 0 1 8.245 3.418 11.588 11.588 0 0 1 3.41 8.246c-.002 6.426-5.23 11.654-11.655 11.654a11.663 11.663 0 0 1-5.574-1.419L16.8 40.32zm6.464-3.732c1.643.975 3.21 1.56 5.285 1.56 5.339 0 9.688-4.345 9.69-9.687a9.683 9.683 0 0 0-9.683-9.694c-5.343 0-9.689 4.345-9.69 9.686-.002 2.18.637 3.813 1.71 5.522l-.979 3.575 3.667-.962zm11.16-5.355c-.073-.121-.267-.194-.559-.34-.291-.146-1.723-.85-1.99-.947-.267-.097-.46-.146-.656.146-.194.29-.753.948-.922 1.142-.17.194-.34.218-.631.072-.291-.146-1.23-.453-2.343-1.446-.865-.772-1.45-1.725-1.62-2.017-.169-.291-.017-.45.128-.594.131-.13.291-.34.437-.51.148-.17.196-.29.294-.486.097-.194.05-.364-.024-.51-.074-.145-.656-1.58-.898-2.162-.237-.568-.477-.491-.656-.5l-.558-.01c-.194 0-.51.073-.776.365-.267.292-1.02.995-1.02 2.43 0 1.433 1.044 2.818 1.19 3.012.145.194 2.052 3.136 4.974 4.397.694.3 1.237.48 1.66.613.697.222 1.332.19 1.834.116.56-.083 1.723-.705 1.966-1.385.243-.68.243-1.264.17-1.386z",
  fill: "#fff"
});

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.1dfde726.svg";
export { ForwardRef as ReactComponent };